module.exports = __webpack_public_path__ + "media/rooster.6a7594ae.mp3";